























import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
import Loading from '../components/Loading.vue';
import moment from 'moment';
@Component({
  components: {
    Loading,
  },
})
export default class DatabaseScreen extends Vue {
  private user: any;
  private beforeTime: any = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  private afterTime: any = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
  // private afterTime: any = moment(new Date()).subtract(-1, 'days').format('YYYY-MM-DD');
  private dateFormat = 'YYYY-MM-DD HH:mm:ss';
  private moment: any = moment;
  private dataTime: any = [this.beforeTime, this.afterTime];
  private spinning = false;
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      console.log('please login');
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private async DownLoadOrderData() {
    const that = this;
    this.spinning = true;
    const url: string = '/api/getDatabaseScreen';
    // const dataTime = [moment(this.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'), this.dataTime[1] + ' 23:59:59'];
    const dataTime = [moment(this.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'),
    moment(this.dataTime[1]).format('YYYY-MM-DD HH:mm:ss')];
    const args = {
      time: dataTime,
      team: this.user.team,
    };
    this.axios.post(url, args, { responseType: 'blob'}).then((res) => {
      const name = that.dataTime[0] + '--' + that.dataTime[1] + '_ScreenData.csv';
      that.downloadFile(res.data, name);
    });
  }
  private async DownLoadWarning() {
    const that = this;
    this.spinning = true;
    const url: string = '/api/getDatabaseWarning';
    const dataTime = [moment(this.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'),
    moment(this.dataTime[1]).format('YYYY-MM-DD HH:mm:ss')];
    const args = {
      time: dataTime,
      team: this.user.team,
    };
    // this.axios.post(url, args, { responseType: 'blob'}).then((res) => {
    //   const name = that.dataTime[0] + '--' + that.dataTime[1] + '_ScreenData.csv';
    //   that.downloadFile(res.data, name);
    // });
    this.axios.post(url, args, { responseType: 'blob'}).then((res) => {
      const name = that.dataTime[0] + '--' + that.dataTime[1] + '_WarnData.zip';
      that.downloadFile(res.data, name);
      this.spinning = false;
    }).catch((err) => {
      this.spinning = false;
    });
  }
  // 下载文件 方法 传入blob数据,和 定义的文件名称
  private downloadFile(data: any, fileName: any) {
    if (!data) {
      return;
    }
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    // 获取文件名
    // download 属性定义了下载链接的地址而不是跳转路径
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    this.spinning = false;
  }
  private onPickerChange(date: any, dateString: string) {
    this.dataTime = dateString;
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.SKUkeyInput as HTMLInputElement;
    inputBox.focus();
  }
}
